import * as THREE from 'three';
import { MeshLine, MeshLineMaterial } from 'three.meshline';

class TextSprite {
  // @param {object} options The options object
  // @param {number} [options.x] The point on the x-axis
  // @param {number} [options.y] The point on the y-axis
  // @param {number} [options.z] The point on the z-axis
  // @param {string} [options.text] The text string
  // @param {number} [options.size] The actual font size
  // @param {number|string} [options.color] The color, css color, for example: #xxxx
  // @param {number} [options.opacity] The opacity of text [0,1]
  constructor(options) {
    options = options || {};
    const { opacity = 1, size = 10 } = options;

    const textObject = new THREE.Object3D();
    const textHeight = 100;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = `normal ${textHeight}px Arial`;
    const metrics = context.measureText(options.text);

    const textWidth = metrics.width;

    canvas.width = textWidth;
    canvas.height = textHeight;

    context.font = `normal ${textHeight}px Arial`;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillStyle = options.color;
    context.fillText(options.text, textWidth / 2, textHeight / 2);

    const texture = new THREE.Texture(canvas);
    texture.needsUpdate = true;
    texture.minFilter = THREE.LinearFilter;

    const material = new THREE.SpriteMaterial({
      map: texture,
      transparent: true,
      opacity: opacity,
      depthTest: false,
    });

    textObject.position.x = options.x || 0;
    textObject.position.y = options.y || 0;
    textObject.position.z = options.z || 0;
    textObject.textHeight = size;
    textObject.textWidth = (textWidth / textHeight) * textObject.textHeight;

    const sprite = new THREE.Sprite(material);
    sprite.scale.set(textWidth / textHeight * size, size, 1);

    textObject.add(sprite);
    return textObject;
  }
}

const createLine = (points, color, lineWidth, opacity) => {
  const meshLine = new MeshLine();
  meshLine.setPoints(points);
  const material = new MeshLineMaterial({
    lineWidth,
    color,
    transparent: true,
    opacity,
    depthTest: false
  });
  return new THREE.Mesh(meshLine, material);
};

class Index extends THREE.Group {
  // 生命周期
  constructor(maxX, maxY, gap) {
    super();

    const colorGrid = 0x444444;
    const colorAxisX = 0xF9656A;
    const colorAxisY = 0x6CBF6A;

    const colorTextX = '#F9656A';
    const colorTextY = '#6CBF6A';

    const lineWidthGrid = 2;
    const lineWidthAxis = 4;

    // 垂直线条
    for (let i = -maxX / gap; i <= maxX / gap; i++) {
      if (i === 0) {
        continue;
      }
      const points = [
        new THREE.Vector3(gap * i, -maxY, 0),
        new THREE.Vector3(gap * i, maxY, 0)
      ];
      this.add(createLine(points, colorGrid, lineWidthGrid, 0.3));
    }
    // 平行线条
    for (let j = -maxY / gap; j <= maxY / gap; j++) {
      if (j === 0) {
        continue;
      }
      const points = [
        new THREE.Vector3(-maxX, gap * j, 0),
        new THREE.Vector3(maxX, gap * j, 0)
      ];
      this.add(createLine(points, colorGrid, lineWidthGrid, 0.3));
    }
    // X 轴线
    {
      const points = [
        new THREE.Vector3(-maxX, 0, 0),
        new THREE.Vector3(maxX, 0, 0)
      ];
      this.add(createLine(points, colorAxisX, lineWidthAxis, 1));
    }
    // Y 轴线
    {
      const points = [
        new THREE.Vector3(0, -maxY, 0),
        new THREE.Vector3(0, maxY, 0)
      ];
      this.add(createLine(points, colorAxisY, lineWidthAxis, 1));
    }
    // 原点 dot
    {
      const geometry = new THREE.SphereGeometry(10, 32, 16);
      const material = new THREE.MeshBasicMaterial({
        color: colorAxisX,
        transparent: true,
        depthTest: false
      });
      const sphere = new THREE.Mesh(geometry, material);
      this.add(sphere);
    }
    // X 轴文字
    for (let i = -maxX / gap; i <= maxX / gap; i++) {
      if (i === 0) {
        continue;
      }
      const textSprite = new TextSprite({
        x: gap * i,
        y: -25,
        text: gap * i,
        size: 30,
        color: colorTextX
      });
      this.add(textSprite);
    }
    // Y 轴文字
    for (let j = -maxY / gap; j <= maxY / gap; j++) {
      if (j === 0) {
        continue;
      }
      const textSprite = new TextSprite({
        x: -40,
        y: gap * j,
        text: gap * j,
        size: 30,
        color: colorTextY
      });
      this.add(textSprite);
    }
    // 顶部 Y
    {
      const textSprite = new TextSprite({
        x: 0,
        y: maxY + 30,
        text: 'Y',
        size: 45,
        color: colorTextY
      });
      this.add(textSprite);
    }
    // 顶部 X
    {
      const textSprite = new TextSprite({
        x: maxX + 30,
        y: 0,
        text: 'X',
        size: 45,
        color: colorTextX
      });
      this.add(textSprite);
    }
  }
}

export default Index;
